import {
  TICKET_LIST_REQUEST_SUCCESS,
  TICKET_LIST_REQUEST_FAIL
} from "../action.types";
import initialValue from "../initial.state";

export default function (state = initialValue.files, action) {
  switch (action.type) {
    case TICKET_LIST_REQUEST_SUCCESS:
      return action.payload.values;
    case TICKET_LIST_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/file/files.reducer.js